import React from "react";

class ViewAvatar extends React.Component {
  state = {};
  currentMember = this.props.globalState.family.filter((value) => {
    return value.id === this.props.globalState.editId;
  })[0];
  partHelper = (part) => {
    return (
      <div className="part">
        <img src={`images/parts/${this.currentMember[part].file}`} alt="" />
      </div>
    );
  };
  statHelper = () => {
    let categories = ["adventure", "relaxing", "cultural", "parks", "city"],
      displayCategories = ["Action/Adventure", "Relaxing", "Cultural", "Theme Parks", "City Slickers"],
      choices = [
        this.currentMember.accessories,
        this.currentMember.gear,
        this.currentMember.outfit,
        this.currentMember.scenery,
      ];
    this.currentMember.totals = {
      adventure: 0,
      city: 0,
      cultural: 0,
      parks: 0,
      relaxing: 0,
      grand: 0,
    };
    this.currentMember.percentages = { ...this.currentMember.totals };
    choices.map((item) => {
      categories.map((category) => {
        this.currentMember.totals[category] += item[category];
        this.currentMember.totals.grand += item[category];
        return null;
      });
      return null;
    });
    let output = categories.map((category, index) => {
      this.currentMember.percentages[category] = Math.round(
        (this.currentMember.totals[category] / this.currentMember.totals.grand) * 100
      );
      return (
        <div key={category} className={`text-nowrap clearfix stat stat-${category}`}>
          <img src={`images/icon-${category}.svg`} className="icon" alt="" />
          {/* <svg className="icon" viewBox="0 0 1 1" role="img" aria-hidden="true">
            <use xlinkHref={`images/parts/icon-${category}.svg#icon`}></use>
          </svg> */}
          {displayCategories[index]}
          <span className="perc">{this.currentMember.percentages[category]}%</span>
        </div>
      );
    });
    return <div>{output}</div>;
  };
  render() {
    this.statHelper();
    console.log(this.props.globalState.family);
    return (
      <div className="view-avatar">
        <section>
          <div className="container">
            <div className="row">
              <div className="col col-lg-8 offset-lg-2 text-center"></div>
            </div>
            <div className="row">
              <div className="col col-lg-8 offset-lg-2 text-right">
                <div className="book">
                  <div className="row flex-column flex-md-row no-gutters">
                    <div className="col">
                      <div className="avatar">
                        {this.partHelper("outfit")}
                        {this.partHelper("gear")}
                        {this.partHelper("accessories")}
                        {this.partHelper("scenery")}
                      </div>
                    </div>
                    <div className="col stats text-left">
                      <div className="stats-inner">
                        <h2>{this.currentMember.name}</h2>
                        {this.statHelper()}
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  className="inline-link"
                  onClick={() => this.props.goTo("BuildAvatar", this.currentMember.id)}
                >
                  Edit<i className="fas fa-pencil" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col text-center actions mt-5">
                <button type="button" className="btn btn-primary" onClick={() => this.props.goTo("BuildAvatar")}>
                  ADD NEXT FAMILY MEMBER
                </button>
                <button type="button" className="btn btn-line" onClick={() => this.props.goTo("Results")}>
                  SEE OUR VACATION STYLE
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default ViewAvatar;
